import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom"; 
import { logVisit } from "../common/analytics/services/analyticsService";
import { getVisitorId } from "../common/analytics/services/visitor";

function AnalyticsTracker() {
    const location = useLocation();

    const previousPath = useRef("");

    useEffect(() => {

        if (previousPath.current === location.pathname)
            return;

        previousPath.current = location.pathname;

        console.log("Analytics called");

        logVisit({
            visitorId: getVisitorId(),
            pageUrl: location.pathname,
            pageTitle: document.title,
            referer: document.referrer
        });

    }, [location.pathname]);

    return null;
}

export default AnalyticsTracker;